import React from 'react';

import { defaultActionCellButtonCDSProps } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';
import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { alwaysTrue } from 'utils/data';
import { getTaskStatusTabLabel } from 'utils/tasks';

import RowActionButton from './components/RowActionButton';
import { COLUMN_WIDTH, LoanConditionTasksTableColumnId } from './LoanConditionTasksTable.constants';

export const getLoanConditionTasksTableConfig = ({ onOpenTaskSLAGroupInfo }) => ({
  [LoanConditionTasksTableColumnId.NAME]: {
    label: 'task name',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.NAME,
    sort: true,
  },
  [LoanConditionTasksTableColumnId.LAST_MODIFIED]: {
    label: 'last modified date',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.LAST_MODIFIED,
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ lastModified }) => dayjs(lastModified).format(COMMON_DATETIME_FORMAT),
  },
  [LoanConditionTasksTableColumnId.STATUS]: {
    label: 'status',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    width: COLUMN_WIDTH.STATUS,
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ status }) => getTaskStatusTabLabel(status),
  },
  [LoanConditionTasksTableColumnId.SLA_LEVEL_DETAILS]: {
    ...defaultActionCellButtonCDSProps,
    content: ({ name, slaGroupId, taskId }) => (
      <RowActionButton
        name={name}
        slaGroupId={slaGroupId}
        taskId={taskId}
        onOpenTaskSLAGroupInfo={onOpenTaskSLAGroupInfo}
      />
    ),
  },
});
